import React from "react";
import ContentInputsTypesEnum from "../../../../enums/ContentInputsTypesEnum";
import generateContentDataObject from "../../../../helpers/editor/generateContentDataObject";
import DebouncedInput from "../../../DebouncedInput";
import { useCurrentInputData } from "../useCurrentInputData";

interface Props {
  item: any;
  saveContentInStore: any;
  contentType: ContentInputsTypesEnum;
  currentInputData: any;
  keyProp: number;
  toggleNewEditionsDetected: (value: boolean) => void;
}

const GallerySliderSubtitle = (props: Props): JSX.Element => {
  const {
    item,
    saveContentInStore,
    contentType,
    currentInputData,
    keyProp,
    toggleNewEditionsDetected,
  } = props;
  const currentInputDataRef = useCurrentInputData(currentInputData);

  const generator = new generateContentDataObject();

  let onChangeGalleryContentSubtitleHandler = (value: any) => {
    saveContentInStore(
      generator.changeGalleryContentSubtitle(
        { [contentType]: currentInputDataRef.current },
        keyProp,
        value
      )
    );
    toggleNewEditionsDetected(true);
  };

  if (!currentInputDataRef.current.contentHasSubtitle) return null;

  return (
    <DebouncedInput
      className="content-input__input"
      onChange={onChangeGalleryContentSubtitleHandler}
      defaultValue={item.contentSubtitle}
      placeholder="Add slide subtitle"
    />
  );
};

export default GallerySliderSubtitle;
